import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=24b206b8&"
import script from "./InfoIcon.vue?vue&type=script&lang=ts&"
export * from "./InfoIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon} from 'quasar'
component.options.components = Object.assign({QIcon}, component.options.components || {})
